import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookOpen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9 5.25V15.75M9 5.25C9 4.45435 8.6839 3.69129 8.12125 3.12868C7.5586 2.56607 6.79547 2.25 5.99976 2.25H2.24946C2.05053 2.25 1.85975 2.32902 1.71909 2.46967C1.57842 2.61032 1.4994 2.80109 1.4994 3V12.75C1.4994 12.9489 1.57842 13.1397 1.71909 13.2803C1.85975 13.421 2.05053 13.5 2.24946 13.5H6.74982C7.3466 13.5 7.91895 13.7371 8.34094 14.159C8.76293 14.581 9 15.1533 9 15.75M9 5.25C9 4.45435 9.3161 3.69129 9.87875 3.12868C10.4414 2.56607 11.2045 2.25 12.0002 2.25H15.7505C15.9495 2.25 16.1402 2.32902 16.2809 2.46967C16.4216 2.61032 16.5006 2.80109 16.5006 3V12.75C16.5006 12.9489 16.4216 13.1397 16.2809 13.2803C16.1402 13.421 15.9495 13.5 15.7505 13.5H11.2502C10.6534 13.5 10.0811 13.7371 9.65906 14.159C9.23707 14.581 9 15.1533 9 15.75",
		stroke: "currentColor",
		strokeWidth: 1.3,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgBookOpen);
export default ForwardRef;
